import { useReducer } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
    Button, FormGroup, FormText, Input, Label
} from "reactstrap";
import { v4 as uuidv4 } from "uuid";
import { createTenant, listTenants } from "../../../actions/Tenants/actions";
import { AvosAction } from "../../../actions/types";

const initialState = {
    tenant_name: "",
    tenant_id: uuidv4(),
};

function reducer(state, { field, value }) {
    return {
        ...state,
        [field]: value,
    };
}

export default function TenantCreateForm() {
    const user = useSelector((state: any) => state.auth.user);
    const tenants = useSelector((state: any) => state.tenants);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [state, dispatchLocal] = useReducer(reducer, initialState);

    const onChange = (e) => {
        dispatchLocal({ field: e.target.name, value: e.target.value });
    };

    const onSubmit = () => {
        Promise.resolve(
            dispatch(createTenant(state) as AvosAction),
        ).then(() => {
            dispatch(listTenants() as AvosAction);
            navigate(`/tenants/${state.tenant_id}`);
        });
    };

    const { tenant_name, tenant_id } = state;

    return user.is_admin ? (
        <div className="d-flex flex-column gap-3">
            <h3 className="pb-2 border-bottom">Add a new tenant</h3>

            <div>
                <FormGroup>
                    <Label for="tenant_name">
                        Tenant name
                    </Label>

                    <Input type="text" name="tenant_name" id="tenant_name" value={tenant_name} onChange={onChange} />

                    <FormText color="muted">
                        Give this tenant a recognizable name
                    </FormText>
                </FormGroup>

                <FormGroup>
                    <Label for="tenant_id">
                        Tenant ID
                    </Label>

                    <Input type="text" name="tenant_id" id="tenant_id" value={tenant_id} onChange={onChange} />

                    <FormText color="muted">
                        Unique identifier for this tenant. This is autogenerated. Overwrite if you want to import from another environment.
                    </FormText>
                </FormGroup>

                <Button color="primary" disabled={tenants.isUpdating} onClick={onSubmit}>
                    Submit
                </Button>
            </div>
        </div>
    ) : null;
}
